import { isStripeEnabled } from "common";
import React, { useState } from "react";
import { Permission } from "types";
import { useSeller, useUser } from "../../hooks/useAccount";
import { useAuthorization } from "../../hooks/useAuthorization";
import { isMultiFactorAuthenticationEnabled, isXolaAdmin } from "../../models/User";
import { MultiFactorAuthenticationInfoModal } from "./MyProfile/MultiFactorAuthenticationCheck";
import { KycRequiredModal } from "./Payments/KycVerificationCheck";
import { isKYCNeeded } from "./Payments/StripePaymentGateway";

export enum MandatoryInformationOptions {
    MFA_SETTING,
    KYC_VERIFICATION,
}

export const MandatoryInformationCheck = ({ option }: { option?: MandatoryInformationOptions }) => {
    const user = useUser();
    const seller = useSeller();
    const { stripeAccount } = seller;
    const verifyKYC = isStripeEnabled(seller) && stripeAccount && isKYCNeeded(stripeAccount);
    const { isGranted } = useAuthorization();
    const hasMFAAccess = isGranted(Permission.ADD_MULTI_FACTOR_AUTHENTICATION_VIEW);

    if (!option) {
        // If no modal option set, check which needs to open
        if (hasMFAAccess && !isXolaAdmin(user) && !isMultiFactorAuthenticationEnabled(user)) {
            option = MandatoryInformationOptions.MFA_SETTING;
        } else if (verifyKYC) {
            option = MandatoryInformationOptions.KYC_VERIFICATION;
        }
    }

    const [selectedOption, setSelectedOption] = useState<MandatoryInformationOptions | null>(option ?? null);
    const resetSelectedOption = () => setSelectedOption(null);

    return (
        <>
            <MultiFactorAuthenticationInfoModal
                showInitalConfigurationMsg
                isOpen={selectedOption === MandatoryInformationOptions.MFA_SETTING}
                // set next modal to open
                onClose={() => setSelectedOption(MandatoryInformationOptions.KYC_VERIFICATION)}
                onConfigure={resetSelectedOption}
            />

            <KycRequiredModal
                isOpen={verifyKYC && selectedOption === MandatoryInformationOptions.KYC_VERIFICATION}
                onClose={resetSelectedOption}
            />
        </>
    );
};
